import * as actions from '../actions/index' 
import cloneDeep from "lodash/cloneDeep"
import set from "lodash/set"

let initialState = {}

function onlySpaces(str) {
	return /^\s*$/.test(str);
}

const productHistRow = (state = initialState, action) => {
	//console.log("hello from the reducer CA!", action.type)
	let newFormData = cloneDeep(state);
	switch(action.type){
		case actions.INITIATE_MAIN_FORM:
			return action.payload
		case actions.UPDATE_MAIN_FORM:{
			if(action.country === "US"){
				if(action.level === "0") {
					newFormData[action.field] = action.value;
				}
				else {
					if(action.index != null) {
						set(newFormData, `${action.level}[${action.index}].${action.field}`, action.value);
					}
				}
			}
			else if(action.country === "UK"){
				if(action.lineItemJson)
				{
					newFormData["lineItemJsonUK"][action.field] = action.value;
				}
				else
				{
					newFormData[action.field] = action.value;
				}
				if(action.field === "countryOfOrigin")
					newFormData["originCountry"] = action.value;
				if(action.field === "commodityCode")
					newFormData["HTS"] = action.value;
				if(action.field === "productTag")
				{
					newFormData["lineItemJsonUK"]["productTag"] = action.value;
					newFormData["lineItemJsonUK"]["sku"] = action.value;
				}
				if(action.field === "productDescription")
					newFormData["lineItemJsonUK"]["commercialDescription"] = action.value;
			}
			else if(action.country === "CA"){
				if(action.lineItemJson)
				{
					newFormData["lineItemJsonCA"][action.field] = action.value;
				}
				else
				{
					newFormData[action.field] = action.value;
				}
				if(action.field === "classificationNo")
					newFormData["HTS"] = action.value;
				if(action.field === "countryOfOrigin")
					newFormData["originCountry"] = action.value;
				if(action.field === "description")
					newFormData["productDescription"] = action.value;
				if(action.field === "manufacturerName"){
					if(!onlySpaces(action.value))
						newFormData["lineItemJsonCA"]["manufacturerStatus"] = "allowed"
					else
						newFormData["lineItemJsonCA"]["manufacturerStatus"] = "waived"
					newFormData["manufacturerName"] = action.value;
				}
				if(action.field === "sku")
					newFormData["productTag"] = action.value;
			}
			return newFormData;
		}
		default:  
			return state;
	}
}

export default productHistRow;